import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { storeProductsResponse } from 'Actions'
import get from 'lodash/get'

class StoreProductsResponse extends Component {
  componentDidMount() {
    this.props.storeProductsResponse(this.props.data)
  }

  componentDidUpdate(prevProps) {
    const fetchFirstId = data => get(data, 'products.products[0].uuid', '')
    if (fetchFirstId(prevProps.data) !== fetchFirstId(this.props.data)) {
      this.props.storeProductsResponse(this.props.data)
    }

    if (prevProps.location.search !== this.props.location.search) {
      this.props.storeProductsResponse(this.props.data)
    }
  }

  render() {
    return null
  }
}

const mapDispatchToProps = dispatch => ({
  storeProductsResponse: bindActionCreators(storeProductsResponse, dispatch)
})

StoreProductsResponse.propTypes = {
  data: PropTypes.any,
  storeProductsResponse: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default connect(null, mapDispatchToProps)(StoreProductsResponse)
